import type { ApiError } from "../api/useApi";

/**
 * Extrait un message d'erreur lisible, en priorisant ce qui est le plus user-friendly :
 *   1. Erreurs de validation 422 (premier message de champ)
 *   2. data.message — message Laravel ou métier (ex : 429 quota exceeded)
 *   3. data.error — clé technique en dernier recours (ex : 500 avec uniquement {error: ...})
 */
export function extractApiError(error: unknown, fallback: string): string {
    if (!error || typeof error !== 'object') return fallback;
    const apiError = error as ApiError & {
        response?: {
            data?: {
                error?: string;
                message?: string;
                errors?: Record<string, string[]>;
            };
        };
    };
    const data = apiError.response?.data;
    if (data?.errors) {
        const first = Object.values(data.errors).find((arr) => arr && arr.length > 0)?.[0];
        if (first) return first;
    }
    if (data?.message) return data.message;
    if (data?.error) return data.error;
    return fallback;
}
